import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import { CircularProgressBar } from 'src/game/components/shared/CircularProgressBar';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { clamp } from 'src/replicant/utils';

export class RoundTimer extends View {
  private progressBar: CircularProgressBar;
  private label: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
    });

    // The white area for the timer number
    new ImageScaleView({
      superview: this,
      image: 'assets/minigame/rescueLevel/timer_frame.png',
      scaleMethod: 'contain',
      width: downscale(291),
      height: downscale(111),
      centerOnOrigin: true,
      x: 80,
    });

    // The circle behind the circular progress bar
    new ImageScaleView({
      superview: this,
      image: 'assets/minigame/rescueLevel/timer_circle.png',
      scaleMethod: 'contain',
      width: downscale(173),
      height: downscale(173),
      centerOnOrigin: true,
      y: 4,
    });

    this.label = new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      size: 32,
      font: 'Body',
      width: 120,
      height: 60,
      color: '#26465C',
      centerOnOrigin: true,
      x: 110,
      localeText: () => '00:30',
    });

    // The actual progress bar
    this.progressBar = new CircularProgressBar({
      superview: this,
      width: downscale(128),
      height: downscale(128),
      progress: 1,
      centerOnOrigin: true,
      flipX: true,
      fillBgStyle: {
        image: 'assets/minigame/rescueLevel/timer_bg.png',
        width: downscale(134),
        height: downscale(134),
      },
      fillStyle: {
        image: 'assets/minigame/rescueLevel/timer_fill.png',
        width: downscale(128),
        height: downscale(128),
      },
    });

    this.progressBar.setFrameOpts({
      visible: false,
    });
  }

  public setTime(remainingMs: number, totalMs: number) {
    if (totalMs <= 0) throw new Error('totalMs must be greater than 0');

    // Clamp the remaining time between 0 and totalMs just in case
    remainingMs = clamp(remainingMs, 0, totalMs);

    // Update the timer text
    const remainingMins = Math.floor(remainingMs / 60000);
    const remainingSecs = Math.floor((remainingMs % 60000) / 1000);
    const remainingMinsStr = remainingMins.toString().padStart(2, '0');
    const remainingSecsStr = remainingSecs.toString().padStart(2, '0');
    this.label.localeText = () => `${remainingMinsStr}:${remainingSecsStr}`;

    // Update the progress bar
    const progress = clamp(remainingMs / totalMs, 0, 1);
    this.progressBar.progress = progress;
  }
}
